import type * as Types from '../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type PhotoAccessFieldsFragment = {
  __typename?: 'MediaInfo';
  photoStorageStatus: Types.PhotoAccessStatus;
  isPhotoStorageBlocked: boolean;
  photoUploadStatus: Types.PhotoAccessStatus;
  isPhotoUploadBlocked: boolean;
  photoStorageExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
  photoUploadExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
};

export type EventPhotoAccessStateQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type EventPhotoAccessStateQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    mediaInfo?: {
      __typename?: 'MediaInfo';
      photoStorageStatus: Types.PhotoAccessStatus;
      isPhotoStorageBlocked: boolean;
      photoUploadStatus: Types.PhotoAccessStatus;
      isPhotoUploadBlocked: boolean;
      photoStorageExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
      photoUploadExpiresAt?: { __typename?: 'Date'; milliseconds: number } | null;
    } | null;
  } | null;
};

export const PhotoAccessFieldsFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoAccessFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoStorageExpiresAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'photoStorageStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPhotoStorageBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoUploadExpiresAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPhotoUploadBlocked' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const EventPhotoAccessStateDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EventPhotoAccessState' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mediaInfo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'PhotoAccessFields' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PhotoAccessFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MediaInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoStorageExpiresAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'photoStorageStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPhotoStorageBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photoUploadExpiresAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'photoUploadStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPhotoUploadBlocked' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useEventPhotoAccessStateQuery__
 *
 * To run a query within a React component, call `useEventPhotoAccessStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventPhotoAccessStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventPhotoAccessStateQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useEventPhotoAccessStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<EventPhotoAccessStateQuery, EventPhotoAccessStateQueryVariables>) {
  return ApolloReactHooks.useQuery<EventPhotoAccessStateQuery, EventPhotoAccessStateQueryVariables>(EventPhotoAccessStateDocument, baseOptions);
}
export function useEventPhotoAccessStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventPhotoAccessStateQuery, EventPhotoAccessStateQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<EventPhotoAccessStateQuery, EventPhotoAccessStateQueryVariables>(EventPhotoAccessStateDocument, baseOptions);
}
export type EventPhotoAccessStateQueryHookResult = ReturnType<typeof useEventPhotoAccessStateQuery>;
export type EventPhotoAccessStateLazyQueryHookResult = ReturnType<typeof useEventPhotoAccessStateLazyQuery>;
export type EventPhotoAccessStateQueryResult = Apollo.QueryResult<EventPhotoAccessStateQuery, EventPhotoAccessStateQueryVariables>;
